var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3594 9.78125L13.4375 0.875C13.2031 0.6875 12.7812 0.546875 12.4531 0.546875C12.1719 0.546875 11.75 0.6875 11.5156 0.875L0.640625 9.78125C0.546875 9.82812 0.5 9.96875 0.5 10.0625C0.5 10.1094 0.5 10.25 0.546875 10.2969L1.01562 10.8594C1.10938 10.9531 1.25 11 1.34375 11C1.39062 11 1.48438 10.9531 1.57812 10.9062L3.5 9.35938V20.75C3.5 21.1719 3.82812 21.5 4.25 21.5H10.25C10.625 21.5 11 21.1719 11 20.75V14.75H14V20.75C14 21.1719 14.3281 21.5 14.75 21.5H20.75C21.125 21.5 21.5 21.1719 21.5 20.75V9.35938L23.375 10.9062C23.4688 10.9531 23.5625 11 23.6094 11C23.75 11 23.8438 10.9531 23.9375 10.8594L24.4062 10.2969C24.4531 10.25 24.4531 10.1094 24.4531 10.0625C24.4531 9.96875 24.4062 9.82812 24.3594 9.78125ZM19.9531 20L15.4531 20.0469V14C15.4531 13.625 15.125 13.25 14.75 13.25H10.25H10.2031C9.82812 13.25 9.45312 13.5781 9.45312 14V20H5V8.14062L12.5 2L20 8.14062L19.9531 20Z",
    fill: "#2D5049"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a457747d38a7b5ab55c449ed37bc1bcf.svg";
export { ForwardRef as ReactComponent };